import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const Hamburger: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M2.5 5C2.5 4.30964 3.05964 3.75 3.75 3.75H16.25C16.9404 3.75 17.5 4.30964 17.5 5C17.5 5.69036 16.9404 6.25 16.25 6.25H3.75C3.05964 6.25 2.5 5.69036 2.5 5ZM2.5 10C2.5 9.30964 3.05964 8.75 3.75 8.75H16.25C16.9404 8.75 17.5 9.30964 17.5 10C17.5 10.6904 16.9404 11.25 16.25 11.25H3.75C3.05964 11.25 2.5 10.6904 2.5 10ZM3.75 13.75C3.05964 13.75 2.5 14.3096 2.5 15C2.5 15.6904 3.05964 16.25 3.75 16.25H16.25C16.9404 16.25 17.5 15.6904 17.5 15C17.5 14.3096 16.9404 13.75 16.25 13.75H3.75Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default Hamburger;